import { object } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { array, string } from 'yup'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { BlogPostLength } from 'components/Wizards/BlogPostWizard/Types'
import { links } from 'components/Wizards/schemas/shared/links'
import { meta } from '../schemaCommon'

export const FlowK1Schema = ({ generationType }: { generationType: string }) => {
  const TopicSelectionSchema = object({
    topic: topic
      .meta({
        type: 'textarea',
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType }),
  }).meta({
    title: 'What would you like to write about?',
    submitLabel: 'Continue',
  }) as StepSchema

  const BlogDetailsSchema = object({
    content_type: string()
      .oneOf(['Promotional', 'Informational', 'Narrative', 'How to', 'Ranking', 'Comparison', 'Custom'])
      .default('Promotional')
      .meta({
        label: `What's the goal of this blog post?`,
        oneOfPills: true,
        size: 'md',
        generate: false,
        generationType,
      })
      .transform(safify),
    audience: string().meta({
      label: `Who is the target audience?`,
      placeholder: 'Enter your target audience...',
      rows: 3,
      generate: true,
      generationType,
      autoFill: true,
    }),
    seo_words: array().of(string()).default([]).meta({
      label: `Keywords`,
      placeholder: 'Add keywords (press return to separate)',
      generate: true,
      generationType,
      autoFill: true,
    }),
  }).meta({
    title: 'Tell us more',
    submitLabel: 'Refine the Details',
  }) as StepSchema

  const FinalDetailsSchema = object({
    blog_length: string()
      .oneOf(Object.values(BlogPostLength))
      .default(BlogPostLength.Medium)
      .meta({ label: 'How long should the post be?' })
      .transform(safify),
    filename,
    project,
  }).meta({
    title: 'Refine details',
    submitLabel: 'Generate Titles',
  }) as StepSchema

  const TitlesSchema = object({
    // Empty schema for now, will add fields later
  }).meta({
    title: 'Select a blog title',
  }) as StepSchema

  const LinksSchema = object({
    links: links.meta({
      label: 'What links would you like to include?',
      placeholder: 'Add links to include in the post',
      autoFill: true,
    }),
  }).meta({
    title: 'What links would you like to include?',
    subtitle:
      'Boost your SEO by incorporating internal and external links. For a short blog post, aim for around 5 links.',
    submitLabel: 'Generate Blog Post',
  }) as StepSchema

  return {
    meta,
    steps: [TopicSelectionSchema, BlogDetailsSchema, FinalDetailsSchema, TitlesSchema, LinksSchema],
  } as MultiStepSchema<ChannelType>
}
